/**
 * Instantiation of all classes / handlers til the main.js is refactored
 */

// Import Classes
import ProjectsSlideShowHandler from "./ProjectsSlideshowHandler.js";
import AccordionHorizontalHandler from "./AccordionHorizontalHandler.js";
import SliderHandler from "./SliderHandler.js";
import HeaderNavigationHandler from "./HeaderNavigationHandler.js";

// Create Objects
const projectsSlideShowHandler = new ProjectsSlideShowHandler();
const accordionHorizontalHandler = new AccordionHorizontalHandler();
const sliderHandler = new SliderHandler();
const headerNavigationHandler = new HeaderNavigationHandler();